/**
 * Initialize collapsible sections within a given root element.
 * Ensures only the first section is open by default.
 * Sets up click handlers so only one section can be open at a time.
 * @param {Element|Document} root - Root element to query for '.collapsible-section'.
 */
function initCollapsibles(root = document) {
    const sections = Array.from(root.querySelectorAll('.tool-tip__content .collapsible-section'));

    // Helper to open a section
    function openSection(section) {
        const content = section.querySelector('.collapsible-content');
        section.classList.remove('collapsible-section-closed');
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
        content.style.visibility = 'visible';
        content.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'max-height') {
                content.style.maxHeight = 'none';
                content.removeEventListener('transitionend', handler);
            }
        });
    }

    // Helper to close a section
    function closeSection(section) {
        const content = section.querySelector('.collapsible-content');
        content.style.maxHeight = content.scrollHeight + 'px';
        content.offsetHeight; // force reflow
        content.style.maxHeight = '0';
        content.style.opacity = '0';
        content.style.visibility = 'hidden';
        section.classList.add('collapsible-section-closed');
    }

    // Initialize states: first open, others closed
    sections.forEach((section, index) => {
        const title = section.querySelector('.collapsible-title');
        // Bind click handler only once
        if (!title._collapsibleBound) {
            title._collapsibleBound = true;
            title.addEventListener('click', () => {
                // Close all except this
                sections.forEach(s => {
                    if (s !== section) closeSection(s);
                });
                // Toggle this one
                if (section.classList.contains('collapsible-section-closed')) {
                    openSection(section);
                } else {
                    closeSection(section);
                }
            });
        }

        // Apply initial open/closed state
        if (index === 0) {
            openSection(section);
        } else {
            closeSection(section);
        }
    });
}

// Wait for DOM to load then observe tooltip open state
document.addEventListener('DOMContentLoaded', () => {
    const tooltip = document.querySelector('tool-tip[data-tool-tip]');
    if (!tooltip) {
        return;
    }

    // Observe opening of tooltip
    const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
            if (
                m.type === 'attributes' &&
                m.attributeName === 'data-tool-tip-open' &&
                tooltip.getAttribute('data-tool-tip-open') === 'true'
            ) {
                initCollapsibles(tooltip);
            }
        }
    });
    observer.observe(tooltip, { attributes: true });

    // Initialize immediately if already open
    if (tooltip.getAttribute('data-tool-tip-open') === 'true') {
        initCollapsibles(tooltip);
    }

    // Check if there is a Size variant
    let sizeVariantInput = document.querySelector('.product-single__meta .variant-input-wrap[data-handle="taglia"]');
    let sizeChart = document.querySelector('.size-chart__standalone');
    if (sizeVariantInput) {
        let sizeVariantLabel = document.querySelector('.product-single__meta .variant__label[for="' + sizeVariantInput.getAttribute('id') + '"]');
        // Move .size-chart__standalone before sizeVariantLabel
        if (sizeChart) {
            let variantWrapper = sizeVariantLabel.parentElement;
            variantWrapper.insertBefore(sizeChart, sizeVariantLabel);
            variantWrapper.classList.add('variant-wrapper__label-with-button');
        }
    }
    else {
        // Remove .size-chart__standalone if there is no Size variant
        if (sizeChart) {
            sizeChart.remove();
        }
    }
});